module.exports = __webpack_public_path__ + "img/case_9.ed696f0a.svg";